import type { IndicatorBase, IndicatorConfig } from '@/types/indicator'

interface IndicatorEntry {
  config: IndicatorConfig
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cls: new (...args: any[]) => IndicatorBase
}

const registry = new Map<string, IndicatorEntry>()

export function registerIndicator(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cls: new (...args: any[]) => IndicatorBase,
  config: IndicatorConfig
) {
  registry.set(config.id, { config, cls })
}

export function getIndicator(id: string): IndicatorEntry | undefined {
  return registry.get(id)
}

export function getAllIndicators(): IndicatorEntry[] {
  return Array.from(registry.values())
}

export function getIndicatorsByCategory(category: IndicatorConfig['category']): IndicatorEntry[] {
  return getAllIndicators().filter((e) => e.config.category === category)
}
